<template>
  <pt-taxation-project-form class="pt-taxation-project-form__page" :id="id" :is-edit="is_edit"></pt-taxation-project-form>
</template>

<script>
import PtTaxationProjectForm from 'cps/finance-manage/pt-taxation-project-manage/pt-taxation-project-form'
export default {
  name: 'pt-taxation-project-form__view',
  components: {
    'pt-taxation-project-form': PtTaxationProjectForm
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
